import CheckIcon from '/public/icons/check.svg';
import LoaderSmall from '/public/icons/loader-small.svg';

interface UploadStatusHeaderProps {
  isSuccess: boolean;
  isOpen: boolean;
  isUploading: boolean;
  totalUploads: number;
  totalSuccessUploads: number;
  entityLabel ?: string
}

export function UploadStatusHeader({
  isSuccess,
  isOpen,
  isUploading,
  totalUploads,
  totalSuccessUploads,
  entityLabel  = ''
}: UploadStatusHeaderProps) {
  if (isSuccess && !isOpen) {
    return (
      <div className="flex items-center gap-[14px]">
        <div className="w-[52px] h-[52px] rounded-[6px] bg-status-success flex items-center justify-center">
          <CheckIcon className="w-10 h-10 fill-current text-white" />
        </div>
        <div className="flex flex-col">
          <h5 className="text-body-medium text-black">Upload successful!</h5>
          <p className="text-body-small text-neutral-700">
            {totalSuccessUploads} of {totalUploads} upload completed
          </p>
        </div>
      </div>
    );
  }

  if (isUploading && !isOpen) {
    return (
      <div className="flex items-center gap-[14px]">
        <div className="w-[52px] h-[52px] rounded-[6px] bg-blue-300 flex items-center justify-center">
          <LoaderSmall className="w-10 h-10 fill-current text-white animate-spin" />
        </div>
        <div className="flex flex-col">
          <h5 className="text-body-medium text-black">Files uploading...</h5>
          <p className="text-body-small text-neutral-700">
            {totalSuccessUploads} of {totalUploads} upload completed
          </p>
        </div>
      </div>
    );
  }

  return <p className="text-blue-900 font-light text-2xl leading-[150%] font-canela"> {entityLabel  != '' ? entityLabel +' - ': ''}  Uploads ({totalUploads}) </p>;
}